import React from "react";
import { IconSize, IconProps } from "../theme";

const InformationIcon: React.FC<IconProps> = ({
  size = IconSize.M,
  color = "#071443",
}) => {
  return (
    <svg
      width={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433284 8.00042 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9972 7.34869 18.9427 4.80678 17.068 2.93202C15.1932 1.05727 12.6513 0.00279983 10 0ZM9.61539 4.61538C9.8436 4.61538 10.0667 4.68306 10.2564 4.80984C10.4462 4.93663 10.5941 5.11683 10.6814 5.32767C10.7687 5.53851 10.7916 5.77051 10.7471 5.99433C10.7025 6.21816 10.5926 6.42375 10.4313 6.58512C10.2699 6.74649 10.0643 6.85638 9.84049 6.9009C9.61667 6.94543 9.38467 6.92258 9.17383 6.83524C8.96299 6.74791 8.78279 6.60002 8.656 6.41027C8.52921 6.22052 8.46154 5.99744 8.46154 5.76923C8.46154 5.46321 8.58311 5.16973 8.79949 4.95334C9.01588 4.73695 9.30937 4.61538 9.61539 4.61538ZM10.7692 15.3846C10.3612 15.3846 9.96989 15.2225 9.68138 14.934C9.39286 14.6455 9.23077 14.2542 9.23077 13.8462V10C9.02676 10 8.8311 9.91895 8.68684 9.7747C8.54259 9.63044 8.46154 9.43478 8.46154 9.23077C8.46154 9.02675 8.54259 8.8311 8.68684 8.68684C8.8311 8.54258 9.02676 8.46154 9.23077 8.46154C9.6388 8.46154 10.0301 8.62362 10.3186 8.91214C10.6071 9.20066 10.7692 9.59197 10.7692 10V13.8462C10.9732 13.8462 11.1689 13.9272 11.3132 14.0715C11.4574 14.2157 11.5385 14.4114 11.5385 14.6154C11.5385 14.8194 11.4574 15.0151 11.3132 15.1593C11.1689 15.3036 10.9732 15.3846 10.7692 15.3846Z"
        fill={color}
      />
    </svg>
  );
};

export default InformationIcon;
